<template>
  <div>
    <div class="d-flex justify-content-between align-items-center pt-50 mb-2">
      <h2 class="font-weight-bolder m-0">
        <span @click="$router.go(-1)">
          <b-button variant="white" class="btn-icon rounded-circle mr-50 text-danger bg-white" style="padding: 0.5px">
            <feather-icon icon="ArrowLeftCircleIcon" size="35" />
          </b-button>
        </span> Crear categoría
      </h2>
    </div>
    <b-card>
      <!-- form -->
      <validation-observer ref="createCategory">
        <b-form
          class="mt-2"
          @submit.prevent="handleSubmit"
          @keydown.enter="handleSubmit"
        >
          <b-row>
            <b-col sm="6">
              <BaseInputText
                v-model="name"
                label="Nombre"
                placeholder="Nombre"
                rules="required"
                localize
              />
              <b-form-group
                :label="'Categoria'"
                label-for="category-parent"
              >
                <v-select
                  label="name"
                  :filterable="false"
                  :searchable="false"
                  :options="selectCategories"
                  v-model="parent"
                  :placeholder="'Categoria'"
                />
              </b-form-group>
              <validation-provider
                  #default="{ errors }"
                  :name="'Orden'"
                  rules="required"
              >
                <b-form-group
                    :label="'Orden'"
                    label-for="category-order"
                >
                  <b-form-input
                      v-model="order"
                      name="order"
                      type="number"
                      min="0"
                      step="1"
                      :placeholder="'Orden'"
                  />
                </b-form-group>
                <small ref="errorField" class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col sm="6">
              <b-form-group
                :label="'Imagen'"
                label-for="product-image"
              >
                <ImageDropzone
                  ref="image"
                  max-files="1"
                />
              </b-form-group>
            </b-col>
            <b-col sm="12">
              <b-form-group
                :label="'Descripción'"
                label-for="category-description"
              >
                <quill-editor
                  v-model="description"
                />
              </b-form-group>
            </b-col>
            <!--Habilitar categoria padre-->
            <b-col cols="12 text-right">
              <b-button
                type="submit"
                variant="primary"
                class="mt-2 mr-1"
              >
                {{ 'Enviar' }}
              </b-button>
            </b-col>
          </b-row>
        </b-form>
      </validation-observer>
    </b-card>
  </div>
</template>

<script>
import FormService from '@/shared/service/form-service'
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'
import { quillEditor } from 'vue-quill-editor'
import BaseInputText from '@/components/ui/input/BaseInputText'
import vSelect from 'vue-select'

export default {
  components: {
    BaseInputText,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    ImageDropzone,
    quillEditor,
    vSelect,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      order: 0,
      name: '',
      parent: '',
      description: '',
      image: '',
      required,
      email,
    }
  },
  computed: {
    ...mapGetters({
      selectCategories: 'categories/getSelectCategoriesParent',
    }),
  },
  methods: {
    ...mapActions({
      getSelectCategories: 'categories/getSelectCategories',
      create: 'categories/create',
    }),
    handleSubmit() {
      this.$refs.createCategory.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.create({ category: formData })
          } else {
            this.$refs.errorField.scrollIntoView({
               behavior: 'smooth',
             block: 'end', 
             });
          }
        }
      })
    },
    createFormData() {
      const data = this.$refs.image.getFormData('myFile')

      if (this.parent) {
        data.append('parent_id', this.parent.id)
      } else {
        data.append('parent_id', '')
      }
      if (this.description !== '' || this.description !== null) {
        data.append('description', this.description)
      }
      FormService.appendEntry(data, this.name, 'name')
      data.append('order', this.order)

      return data
    },
  },
  async created() {
    await this.getSelectCategories({ parent: 0 })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
